import React, { useCallback, useEffect, useState, memo } from "react";
import Table from "../components/table/Table";
import config from "../api/config";
import "../assets/css/customers.css";

import { useDispatch, useSelector } from "react-redux";
import { setToast } from "../redux/actions/ToastAction";
import { Button, Snackbar } from "@mui/material";
import Alert from "../components/alert";
import { useHistory } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

const SearchHistory = () => {
    const { location } = useHistory();
    const navigate = useHistory();
    const state = location.user;
  const [searches, setsearches] = useState([]);
  const [total, setTotal] = useState(0);

  const [currpage, setCurrPage] = useState(0);
  const [, setPage] = useState(0);
  const [loading, setLoading] = useState(false);

  // modal

  // snackbar
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  // search searches

  // change pages
  const pageHandler = useCallback((page) => {
    setLoading(true);
    setPage(page);
    config
      .get(`/api/googleResults/v1?page=${page}&size=100&userTelegramId=${state}`)
      .then((data) => {
        setLoading(false);

        setsearches(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });

  }, [state]);

  // rolechanger

  // get data
  useEffect(() => {
    if (state) pageHandler(0);
  }, [pageHandler, state]);

  // table data
  const headData = ["Имя", "link", "Ключевые слова"];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item, index) => (
    <tr key={index}>
      <td>
        <p>{item.title}</p>
      </td>
      <td>
        <span>
          <a href={item.url} target="_blank" rel="noopener noreferrer">
            {item.displayLink}
          </a>
        </span>
      </td>
      <td>
        <p> {item.key}</p>
      </td>

    </tr>
  );

  return (
    <div>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      <Button
        onClick={() => navigate.push(`/users`)}
        variant="outlined"
        style={{
          padding: "12px 22px",
          borderRadius: "40px",
          fontWeight: "bold",
        }}
      >
        <IoIosArrowBack />
      </Button>
      <h2 className="page-header mt-3">История поиска</h2>
      <div className="row ">
        <div className="col-12">
          {searches?.length > 0 ? (
            <Table
              headData={headData}
              renderHead={(item, index) => renderHead(item, index)}
              bodyData={searches}
              renderBody={(item, index) => renderBody(item, index)}
              pages={total}
              currPage={currpage}
              changePage={pageHandler}
              loading={loading}
            />
          ) : (
            <div>Нет данных</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(SearchHistory);
